import { render, staticRenderFns } from "./programList.vue?vue&type=template&id=681c10c0&"
import script from "./programList.vue?vue&type=script&lang=js&"
export * from "./programList.vue?vue&type=script&lang=js&"
import style0 from "./programList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports